import {
  MenuMultiOption,
  MenuMulti,
  ButtonSelect,
  Badge,
} from "@saviynt/design-system";
import { useState, useEffect, useRef } from "react";

interface PoliciesFilterOptionsProps {
  label: string;
  filterOptions: MenuMultiOption[];
}

export default function PoliciesFilterOptions({
  label,
  filterOptions,
  onFilterChange,
  clearTrigger,
}: PoliciesFilterOptionsProps & {
  onFilterChange: (label: string, value: MenuMultiOption[]) => void;
  clearTrigger: number;
}) {
  const [options, setOptions] = useState<MenuMultiOption[]>(filterOptions);
  const isFirstRender = useRef(true);

  useEffect(() => {
    setOptions(filterOptions);
  }, [filterOptions]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setOptions((currentOptions) =>
      currentOptions.map((option) => ({
        ...option,
        isChecked: false,
      })),
    );
  }, [clearTrigger]);

  const isOptionChecked = options.some((option) => option.isChecked);

  const handleChange = (selectedOptions?: MenuMultiOption[]) => {
    setOptions(
      options.map((option) => ({
        ...option,
        isChecked: selectedOptions?.some(
          (selectedOption) => selectedOption.value === option.value,
        ),
      })),
    );

    onFilterChange(label, selectedOptions ?? []);
  };

  return (
    <MenuMulti
      options={options}
      label={label}
      onChange={handleChange}
      trigger={
        <ButtonSelect
          kind="pill"
          label=""
          BadgeComp={
            isOptionChecked ? (
              <Badge kind="dot" color="primary" size="small" />
            ) : undefined
          }
        />
      }
      minOptionsForSearch={1}
      minOptionsForFooter={1}
    />
  );
}
